// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper___30ppU","morebox":"morebox___2YERC","icon-more":"icon-more___zngcJ"};